module.exports = __webpack_public_path__ + "img/64.2f86c11.png";